import { render, staticRenderFns } from "./V2ShipAllOrderStep.vue?vue&type=template&id=2e8aa832&scoped=true&"
import script from "./V2ShipAllOrderStep.vue?vue&type=script&lang=js&"
export * from "./V2ShipAllOrderStep.vue?vue&type=script&lang=js&"
import style0 from "./V2ShipAllOrderStep.vue?vue&type=style&index=0&id=2e8aa832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8aa832",
  null
  
)

export default component.exports